import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%'
  },

  img: {
    margin: '0 0.5rem',
    height: '2rem',
    width: 'auto'
  }
}))

export default useStyles
